import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpContext} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ChartTemplate} from '../model/Theme';
import {SKIP_ERROR_TOAST} from '../commons/interceptor/http-error';

@Injectable({
    providedIn: 'root'
})
export class ChartTemplateService {
    private baseUrl = `${environment.apiBaseUrl}/charts/templates`;

    constructor(private http: HttpClient) {
    }

    getAll(): Observable<ChartTemplate[]> {
        return this.http.get<ChartTemplate[]>(this.baseUrl);
    }

    remove(id: string) {
        return this.http.delete(`${this.baseUrl}/${id}`);
    }

    save(chart: ChartTemplate): Observable<ChartTemplate> {
        return this.http.put<ChartTemplate>(this.baseUrl, chart);
    }

    copy(id: string): Observable<ChartTemplate> {
        return this.http.post<ChartTemplate>(this.baseUrl + `/${id}/copy`, null, {
            context: new HttpContext().set(SKIP_ERROR_TOAST, true)
        });
    }

    upload(formData: FormData): Observable<ChartTemplate> {
        return this.http.post<ChartTemplate>(`${this.baseUrl}/upload`, formData);
    }

}
